import NuisancesWidget from './nuisances-widget';
import { IInsightPreview } from 'components/widget/common/styled';
import { State } from 'store/state';
import { connect } from 'react-redux';
import { setActiveNuisanceCarouselIdx, setActiveNuisance } from 'store/state/insightsContext/actions';
import { activeNuisanceCarouselIdxSelector } from 'store/state/insightsContext/selectors';
import { nuisancesCarouselDataSelector } from 'store/state/selectors/insights/nuisances';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';


export interface NuisancesWidgetProps {
  carouselData: IInsightPreview[];
  setActiveInsightId: (id: string) => void;
  setActiveCarouselIdx: (index: number) => void;
  carouselIdx: number;
  isCollapsed: boolean;
  showCarousel: boolean;
}

const mapStateToProps = (state: State) => ({
  carouselData: nuisancesCarouselDataSelector(state),
  carouselIdx: activeNuisanceCarouselIdxSelector(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToProps = {
  setActiveInsightId: setActiveNuisance,
  setActiveCarouselIdx: setActiveNuisanceCarouselIdx,
};

export default connect(mapStateToProps, mapDispatchToProps)(NuisancesWidget);
